<template>
  <div>
    <div v-if="loading" class="partLoading">
      <mt-spinner color="#01B5CE" type="fading-circle"></mt-spinner>
    </div>
  </div>
</template>

<script>
export default {
  props: ['loading']
}
</script>

<style scoped lang="less">
.partLoading {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
</style>
